





































import { Checkbox } from '@alpha/ink'
import Subheader from '@/components/Subheader.vue'
import preQualificationTypes from '@/utilities/pq-types'
import preQualificationInternational from '@/assets/json/pqInternational.json'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Checkbox,
    Subheader
  }
})
export default class AudiencePrequalPicker extends Vue {
  @Prop({ required: true }) readonly prequalificationGroups!: string[]
  @Prop({ required: true }) readonly criteriaOrder!: string[]
  @Prop({ required: true }) readonly selectedCriteria!: string[]

  preQualificationTypes = Object.assign(preQualificationTypes, preQualificationInternational)

  toggleCriterion (criterion: string) {
    this.$emit('update', { criteria: criterion })
  }
}
